import { isEmptyContent } from "client/Components/RichTextEditor/htmlConversion";
import { isProseMirror, RichTextEditorState } from "client/Components/RichTextEditor/types";
import { useMemo } from "react";
import { PostComposerFormData } from "./common";
import { isNotNil } from "client/Misc/utils";

export function useIsEmpty(
	formData: PostComposerFormData,
	intermediateState: RichTextEditorState
): boolean {
	return useMemo(
		(): boolean => {
			if (!isProseMirror(intermediateState)) {
				throw new Error("Editor not supported");
			}

			const {
				images,
				poll,
				linkedDocuments
			} = formData;

			const hasImage: boolean = images.length > 0;
			const hasPoll: boolean = poll.isSet && isNotNil(poll.value);
			const hasLinkedDocuments: boolean = linkedDocuments.length > 0;

			return isEmptyContent(intermediateState.editorState)
				&& !hasImage
				&& !hasPoll
				&& !hasLinkedDocuments;
		},
		[intermediateState, formData]
	);
}
